import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';
import { TabViewModule } from 'primeng/tabview';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { TransactionsRevisionReasonsListComponent } from './transactions-revision-reasons-list/transactions-revision-reasons-list.component';
import { TransactionsRevisionReasonsDetailComponent } from './transactions-revision-reasons-detail/transactions-revision-reasons-detail.component';
import { TransactionsRevisionReasonsRoutingModule } from './transactions-revision-reasons-routing.module';


import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [
        TransactionsRevisionReasonsListComponent,
        TransactionsRevisionReasonsDetailComponent
    ], imports: [CoreModule,
        TransactionsRevisionReasonsRoutingModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        InputSwitchModule,
        ConfirmDialogModule,
        PanelModule,
        CheckboxModule,
        TabViewModule,
        DialogModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class TransactionsRevisionsModule { }
